




























import Vue from 'vue';
import { Icon, Toast } from '@/components/ds';
import CourseModal from './modals/CourseModal.vue';
import CampusModal from './modals/CampusModal.vue';
import { isProuniVoucher } from '@/helpers/prouniVoucher';

interface Data {
  courseModalActive: boolean;
  campusModalActive: boolean;
  errorMessageLabel: string;
}

export default Vue.extend({
  components: { Icon, CourseModal, CampusModal, Toast },
  data(): Data {
    return {
      courseModalActive: false,
      campusModalActive: false,
      errorMessageLabel: '',
    };
  },
  computed: {
    courseName(): string {
      return this.$store.getters.courseName ?? '';
    },
    campusTitle(): string {
      const { campus } = this.$store.getters;
      if (!campus) return '';
      return `${campus?.name}, ${campus?.city} - ${campus?.state}`;
    },
    // No ProUni curso e polo vêm travados da allowlist e já foram provisionados
    // na admissão — trocar aqui desfaria a bolsa.
    isProuniEnrollment(): boolean {
      return isProuniVoucher(this.$store.getters.partnerCode);
    },
    canChangeCourseCampus(): boolean {
      const academicRecord = this.$store.getters.backofficeStudentAcademicRecord ?? null;
      const isJacadCourse = this.$store.getters.isJacadCourse === true;
      return !academicRecord && !isJacadCourse && !this.isProuniEnrollment;
    },
  },
  methods: {
    closeCourseModal() {
      this.courseModalActive = false;
    },
    openCourseModal() {
      this.courseModalActive = true;
    },
    closeCampusModal() {
      this.campusModalActive = false;
    },
    openCampusModal() {
      this.campusModalActive = true;
    },
    triggerError(errorMessageLabel: string) {
      this.errorMessageLabel = errorMessageLabel;

      setTimeout(() => {
        this.errorMessageLabel = '';
      }, 3000);
    },
  },
});
